import React, { memo, useCallback, useMemo } from 'react';
import { useDispatch } from 'react-redux';

import { Typography } from '@mui/material';
import AccordionCDS from 'app/shared/componentsRestyled/coreDesignSystem/AccordionCDS';
import dayjs from 'dayjs';
import withLoading, { WithLoadingPropTypes } from 'hocs/withLoading';
import PropTypes from 'prop-types';
import { compose } from 'redux';

import { COMMON_DATETIME_FORMAT } from 'constants/date';

import { getUwReportByReportIdAction } from 'store/loanApplications/actions';

import { UnderwritingTestIds } from '../../Underwriting.testIds';
import Incomes from '../Incomes';
import { config } from '../UwReports.config';

import { accordionCustomStyles } from './UwReportsItem.styles';

const UwReportsItem = ({ isLoading, setIsLoading, item }) => {
  const dispatch = useDispatch();

  const { reportId } = item;
  const title = item.createdDate ? dayjs(item.createdDate).format(COMMON_DATETIME_FORMAT) : 'N/A';

  const additionalSummaryContent = useMemo(
    () =>
      Object.keys(config)
        .filter(key => key !== 'createdDate')
        .map(key => (
          <Typography data-truncated className="truncate" key={key} variant="regular14">
            {item[key]}
          </Typography>
        )),
    [item],
  );

  const onAccordionExpand = useCallback(
    (__, isExpanded) => {
      if (isExpanded) {
        setIsLoading(true);

        dispatch(getUwReportByReportIdAction({ reportId })).finally(() => setIsLoading(false));
      }
    },
    [setIsLoading, dispatch, reportId],
  );

  return (
    <AccordionCDS
      additionalSummaryContent={additionalSummaryContent}
      arrowSize={18}
      className="py-2"
      customStyles={accordionCustomStyles}
      data-testid={UnderwritingTestIds.getUwReportItemId(reportId)}
      title={title}
      onChange={onAccordionExpand}
    >
      <Incomes incomes={item.incomesSection} isLoading={isLoading} />
    </AccordionCDS>
  );
};

UwReportsItem.propTypes = {
  ...WithLoadingPropTypes,
  item: PropTypes.shape({
    reportId: PropTypes.string,
    createdDate: PropTypes.string,
    informationalAlerts: PropTypes.number,
    warningAlerts: PropTypes.number,
    severeAlerts: PropTypes.number,
  }).isRequired,
};

export default compose(withLoading, memo)(UwReportsItem);
